import { useEffect, useMemo, useState } from 'react';
import getFactoryList from '../../api/cars/getFactoryList';
import { CAR_ORIGIN_TYPES, CAR_ORIGIN_LABELS } from '../../constants/carOrigin';

// "ÐÐ¾Ð²Ð¾Ðµ Ð°Ð²ÑÐ¾, Ð¿ÑÐ¾Ð¸Ð·Ð²ÐµÐ´ÑÐ½Ð½Ð¾Ðµ Ð² ÐÐ°Ð·Ð°ÑÑÑÐ°Ð½Ðµ" Ð½Ð° Ð´ÐµÐ»Ðµ Ð½Ðµ ÐµÐ´Ð¸Ð½ÑÐ¹ Ð²Ð°ÑÐ¸Ð°Ð½Ñ Ð¸Ð·
// origin_car_list, Ð° ÐºÐ¾Ð¼Ð±Ð¸Ð½Ð°ÑÐ¸Ñ origin=NEW_KZ + ÐºÐ¾Ð½ÐºÑÐµÑÐ½ÑÐ¹ Ð·Ð°Ð²Ð¾Ð´ (Cars.factoryId,
// Ð¾ÑÐ´ÐµÐ»ÑÐ½Ð°Ñ ÑÐ°Ð±Ð»Ð¸ÑÐ° Factory) â ÑÐ¾ Ð¶Ðµ ÑÐ°Ð¼Ð¾Ðµ, ÑÑÐ¾ ÑÐ¾Ð±Ð¸ÑÐ°ÐµÑ ÑÐ¾ÑÐ¼Ð° ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ Ð°Ð²ÑÐ¾
// (pages/Car/NewCar/CarCreate.jsx). ÐÐ¾Ð´ÑÑÐ°Ð²Ð»ÑÐµÐ¼ ÑÐ¿Ð¸ÑÐ¾Ðº Ð·Ð°Ð²Ð¾Ð´Ð¾Ð² Ð²Ð¼ÐµÑÑÐ¾ Ð±Ð°Ð·Ð¾Ð²Ð¾Ð³Ð¾
// NEW_KZ, ÐºÐ°Ðº Ð¸ ÑÐ°Ð¼, ÑÑÐ¾Ð±Ñ Ð¿ÑÐ¸ ÑÑÑÐ½Ð¾Ð¹ Ð¿ÑÐ°Ð²ÐºÐµ Ð¸Ð¼Ð¿Ð¾ÑÑÐ° Ð¼Ð¾Ð¶Ð½Ð¾ Ð±ÑÐ»Ð¾ Ð²ÑÐ±ÑÐ°ÑÑ
// ÐºÐ¾Ð½ÐºÑÐµÑÐ½ÑÐ¹ Ð·Ð°Ð²Ð¾Ð´, Ð° Ð½Ðµ ÑÐ¾Ð»ÑÐºÐ¾ "ÐÐ¾Ð²Ð¾Ðµ Ð°Ð²ÑÐ¾, Ð¿ÑÐ¾Ð¸Ð·Ð²ÐµÐ´ÑÐ½Ð½Ð¾Ðµ Ð² ÐÐ°Ð·Ð°ÑÑÑÐ°Ð½Ðµ" Ð±ÐµÐ·
// ÑÑÐ¾ÑÐ½ÐµÐ½Ð¸Ñ
export const decomposeOrigin = (option) => {
  if (!option) return { originCarId: 0, factoryId: null };
  if (typeof option.value === 'string' && option.value.startsWith('factory_')) {
    return { originCarId: CAR_ORIGIN_TYPES.NEW_KZ, factoryId: option.factoryId };
  }
  return { originCarId: option.value, factoryId: null };
};

const useOriginOptions = () => {
  const [factoryList, setFactoryList] = useState([]);

  useEffect(() => {
    getFactoryList()
      .then((res) => setFactoryList(res?.data?.data || []))
      .catch(() => {});
  }, []);

  // ÐÐµÐ¼Ð¾Ð¸Ð·Ð¸ÑÑÐµÐ¼ â Ð±ÐµÐ· ÑÑÐ¾Ð³Ð¾ ÑÑÐº Ð¾ÑÐ´Ð°Ð²Ð°Ð» Ð½Ð¾Ð²ÑÐ¹ Ð¼Ð°ÑÑÐ¸Ð² Ð½Ð° ÐºÐ°Ð¶Ð´ÑÐ¹ ÑÐµÐ½Ð´ÐµÑ, Ð¸Ð·-Ð·Ð°
  // ÑÐµÐ³Ð¾ Ñ Ð»ÑÐ±Ð¾Ð³Ð¾ Ð¿Ð¾ÑÑÐµÐ±Ð¸ÑÐµÐ»Ñ (Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ React.memo-ÑÑÑÐ¾Ðº Ð²
  // StockPendingRowsTable) ÑÑÑÐ»ÐºÐ° Ð½Ð° options Ð¼ÐµÐ½ÑÐ»Ð°ÑÑ Ð²ÑÐµÐ³Ð´Ð°, Ð´Ð°Ð¶Ðµ ÐºÐ¾Ð³Ð´Ð°
  // ÑÐ¿Ð¸ÑÐ¾Ðº ÑÐ°ÐºÑÐ»ÑÑÐ°ÑÐ¸Ð²Ð½Ð¾ Ð½Ðµ Ð¼ÐµÐ½ÑÐ»ÑÑ
  return useMemo(() => {
    const baseOptions = Object.keys(CAR_ORIGIN_TYPES)
      .filter((key) => CAR_ORIGIN_TYPES[key] !== CAR_ORIGIN_TYPES.NEW_KZ)
      .map((key) => ({
        value: CAR_ORIGIN_TYPES[key],
        label: CAR_ORIGIN_LABELS[CAR_ORIGIN_TYPES[key]],
      }));

    if (factoryList.length > 0) {
      const factoryOptions = factoryList.map((factory) => ({
        value: `factory_${factory.id}`,
        label: 'ÐÐ¾Ð²Ð¾Ðµ Ð°Ð²ÑÐ¾, ' + factory.name,
        factoryId: factory.id,
      }));
      return [...factoryOptions, ...baseOptions];
    }

    return [
      { value: CAR_ORIGIN_TYPES.NEW_KZ, label: CAR_ORIGIN_LABELS[CAR_ORIGIN_TYPES.NEW_KZ] },
      ...baseOptions,
    ];
  }, [factoryList]);
};

export default useOriginOptions;
